export const getPrLine = ({ actionsHistory }) => {
	const actions = actionsHistory
	const line = []

	for (let i = 0; i < actions.length; i++) {
		if (actions[i].type === 'flop') {
			break
		}

		if (actions[i].type === 'action') {
			line.push(
				actions[i]?.action?.toLowerCase() === 'check' ? 'X' : actions[i].isAllIn ? 'A' : actions[i].action.split('')[0]
			)
		}
	}

	return line.join('')
}
export const getFLine = ({ actionsHistory }) => {
	const actions = actionsHistory

	const line = []
	let startLine = false
	for (let i = 0; i < actions.length; i++) {
		if (actions[i].type === 'turn') {
			break
		}

		if (startLine) {
			line.push(
				actions[i]?.action?.toLowerCase() === 'check' ? 'X' : actions[i].isAllIn ? 'A' : actions[i].action.split('')[0]
			)
		}
		if (actions[i].type === 'flop') {
			startLine = true
		}
	}

	return line.join('')
}
export const getTLine = ({ actionsHistory }) => {
	const actions = actionsHistory

	const line = []
	let startLine = false
	for (let i = 0; i < actions.length; i++) {
		if (actions[i].type === 'river') {
			break
		}

		if (startLine) {
			line.push(
				actions[i]?.action?.toLowerCase() === 'check' ? 'X' : actions[i].isAllIn ? 'A' : actions[i].action.split('')[0]
			)
		}
		if (actions[i].type === 'turn') {
			startLine = true
		}
	}

	return line.join('')
}
export const getRLine = ({ actionsHistory }) => {
	const actions = actionsHistory
	const line = []
	let startLine = false
	for (let i = 0; i < actions.length; i++) {
		if (startLine) {
			line.push(
				actions[i]?.action?.toLowerCase() === 'check' ? 'X' : actions[i].isAllIn ? 'A' : actions[i].action.split('')[0]
			)
		}
		if (actions[i].type === 'river') {
			startLine = true
		}
	}

	return line.join('')
}

export const getPlayerPrLine = ({ actionsHistory, player }) => {
	const actions = actionsHistory
	const line = []
	for (let i = 0; i < actions.length; i++) {
		if (actions[i].type === 'flop') {
			break
		}
		if (player === actions[i].role) {
			line.push(
				actions[i]?.action?.toLowerCase() === 'check' ? 'X' : actions[i].isAllIn ? 'A' : actions[i].action.split('')[0]
			)
		}
	}

	return line.join('')
}

export const getPlayerFLine = ({ actionsHistory, player }) => {
	const actions = actionsHistory

	const line = []
	let startLine = false
	for (let i = 0; i < actions.length; i++) {
		if (actions[i].type === 'turn') {
			break
		}

		if (startLine && player === actions[i].role) {
			line.push(
				actions[i]?.action?.toLowerCase() === 'check' ? 'X' : actions[i].isAllIn ? 'A' : actions[i].action.split('')[0]
			)
		}
		if (actions[i].type === 'flop') {
			startLine = true
		}
	}

	return line.join('')
}

export const getPlayerTLine = ({ actionsHistory, player }) => {
	const actions = actionsHistory
	const line = []
	let startLine = false
	for (let i = 0; i < actions.length; i++) {
		if (actions[i].type === 'river') {
			break
		}

		if (startLine && player === actions[i].role) {
			line.push(
				actions[i]?.action?.toLowerCase() === 'check' ? 'X' : actions[i].isAllIn ? 'A' : actions[i].action.split('')[0]
			)
		}
		if (actions[i].type === 'turn') {
			startLine = true
		}
	}

	return line.join('')
}

export const getPlayerRLine = ({ actionsHistory, player }) => {
	const actions = actionsHistory
	const line = []
	let startLine = false
	for (let i = 0; i < actions.length; i++) {
		if (startLine && player === actions[i].role) {
			line.push(
				actions[i]?.action?.toLowerCase() === 'check' ? 'X' : actions[i].isAllIn ? 'A' : actions[i].action.split('')[0]
			)
		}
		if (actions[i].type === 'river') {
			startLine = true
		}
	}

	return line.join('')
}
